import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { marked } from "marked";
import Parser from "html-react-parser";
import jobProfileType from "../types/jobProfileType";
import { PdfExportPageType } from "../types/exportModalTypes";
import {
  ExportPageWrapper,
  CompanyName,
  Title,
  Info,
  Column,
  InfoLine,
  SectionTitle,
} from "../styles/export-pdf-styles";

export const PdfExportPage: FunctionComponent<PdfExportPageType> = ({
  jobProfile,
  salarySelected,
  feeSelected,
  agencyBriefingSelected,
  benefitsSelected,
  recruiterCompanyName,
}) => {
  const keySkillsArray = jobProfile.keySkills.split(",");

  const benefits = jobProfile.benefitOptions.filter(
    (option) => jobProfile.benefitIds.includes(option.id) && option.name
  );

  const isPermanent = jobProfile.jobType === "permanent";

  return (
    <ExportPageWrapper id="job-profile-export">
      <CompanyName>{recruiterCompanyName}</CompanyName>
      <Title>{jobProfile.jobTitle}</Title>
      <Info>
        <Column>
          <InfoLine>
            <strong>Location: </strong> {jobProfile.location}
          </InfoLine>
          <InfoLine>
            <strong>Type: </strong> {jobProfile.jobType}
          </InfoLine>
          {salarySelected && (
            <InfoLine>
              <strong>{isPermanent ? "Salary" : "Day rate"}: </strong>{" "}
              {jobProfile.salaryType === "range"
                ? jobProfile.salaryRange
                : `${jobProfile.currencySymbol}${jobProfile.salaryMin}`}
            </InfoLine>
          )}
        </Column>
        <Column>
          <InfoLine>
            <strong>Visa Sponsorship: </strong>{" "}
            {jobProfile.visaSponsorship ? "Yes" : "No"}
          </InfoLine>
          <InfoLine>
            <strong>Degree Required: </strong>{" "}
            {jobProfile.degreeRequired ? "Yes" : "No"}
          </InfoLine>
          <InfoLine>
            <strong>Relocation: </strong>{" "}
            {jobProfile.considerRelocation ? "Yes" : "No"}
          </InfoLine>
        </Column>
        <Column>
          {jobProfile.jobType === "contract" && (
            <InfoLine>
              <strong>Contract Duration: </strong>{" "}
              {`${jobProfile.contractDuration} ${jobProfile.contractDurationInterval}`}
            </InfoLine>
          )}
          {feeSelected && (
            <InfoLine>
              <strong>Fee: </strong> {`${jobProfile.recruiterFeePercentage}%`}
            </InfoLine>
          )}
        </Column>
      </Info>
      {agencyBriefingSelected && (
        <>
          <SectionTitle>Agency Briefing:</SectionTitle>
          {Parser(marked(jobProfile.agencyBriefing))}
        </>
      )}
      <SectionTitle>Description:</SectionTitle>
      {Parser(jobProfile.description)}
      <SectionTitle>Must Haves:</SectionTitle>
      <ul>
        {keySkillsArray.map((skill) => (
          <li key={skill}>{skill}</li>
        ))}
      </ul>
      {benefitsSelected && (
        <>
          <SectionTitle>Benefits:</SectionTitle>
          <ul>
            {benefits.map(({ id, name }) => (
              <li key={id}>{name}</li>
            ))}
          </ul>
        </>
      )}
    </ExportPageWrapper>
  );
};

PdfExportPage.propTypes = {
  jobProfile: jobProfileType.isRequired,
  salarySelected: PropTypes.bool.isRequired,
  feeSelected: PropTypes.bool.isRequired,
  agencyBriefingSelected: PropTypes.bool.isRequired,
  benefitsSelected: PropTypes.bool.isRequired,
  recruiterCompanyName: PropTypes.string.isRequired,
};

export default PdfExportPage;
